package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import io.horion.cv.models.CompetenceState
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.api.datasource.cv.Level
import io.horion.cv.components.cards.GenericFormCard
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.widgets.AddButton
import io.horion.cv.di.koinGet
import org.jetbrains.compose.web.css.px

@Composable
fun CompetenceAccordionContent(
    onComplete: (String) -> Unit,
    onAddCompetenceAndClose: (String) -> Unit
) {
    val cvViewModel = koinGet<CvViewModel>()
    val cvUiState = cvViewModel.cvUiState
    val competencesFromVM = cvUiState.data.competences


    LaunchedEffect(Unit) {
        if (competencesFromVM.isEmpty()) {
            cvViewModel.updateCompetence(
                0,
                io.horion.cv.api.datasource.cv.Competence("", Level.BEGINNER)
            )
            cvViewModel.editingCompetenceId = "competence-0"
        }
    }

    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(30.px),
    ) {
        competencesFromVM.forEachIndexed { index, comp ->
            val tempId = "competence-$index"

            val competenceState = remember(comp) {
                CompetenceState(
                    id = tempId,
                    competence = comp.name,
                    niveau = if (comp.name.isEmpty()) "" else (reverseNiveauMapping[comp.level] ?: "")
                )
            }

            GenericFormCard(
                item = competenceState,
                isEditing = cvViewModel.editingCompetenceId == tempId,
                onEdit = { cvViewModel.editingCompetenceId = tempId },
                onDelete = {
                    cvViewModel.deleteCompetence(index)
                    if (cvViewModel.cvUiState.data.competences.isEmpty()) {
                        cvViewModel.updateCompetence(
                            0,
                            io.horion.cv.api.datasource.cv.Competence("", Level.BEGINNER)
                        )
                        cvViewModel.editingCompetenceId = "competence-0"
                    } else {
                        cvViewModel.editingCompetenceId = null
                    }
                },
                onComplete = {
                    cvViewModel.editingCompetenceId = null
                },
                getSummary = { c ->
                    if (c.competence.isNotBlank() || c.niveau.isNotBlank()) {
                        SummaryData(
                            title = c.competence.ifBlank { "[Compétence]" },
                            subtitle = c.niveau.ifBlank { "[Niveau]" }
                        )
                    } else null
                },
                getDefaultText = { "[Compétence]" },
                formContent = { state, onDel, onComp ->
                    CompetenceForm(
                        index = index,
                        state = state,
                        cvViewModel = cvViewModel,
                        onDelete = onDel,
                        onComplete = onComp
                    )
                }
            )
        }

        AddButton(
            text = "Ajouter une compétence",
            onClick = {
                val nextIndex = competencesFromVM.size
                cvViewModel.updateCompetence(
                    nextIndex,
                    io.horion.cv.api.datasource.cv.Competence("", Level.BEGINNER)
                )
                cvViewModel.editingCompetenceId = "competence-$nextIndex"
            }
        )
    }
}